import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import Header_Company from "../../Components/Header_Company";
import { BASE_URL } from "../../Config";

const RetailPackages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);

  // Get userId from session storage
  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      setUserId(userData.userId);
    } else {
      Swal.fire("Error", "No user data found in sessionStorage.", "error");
    }
  }, []);

  // Fetch packages after userId is available
  useEffect(() => {
    const fetchPackages = async () => {
      if (!userId) return; // Wait until userId is available

      setLoading(true);
      try {
        const response = await axios.get(
          `${BASE_URL}RetailCompanyPackage?id=${userId}`,
          { headers: { accept: "*/*" } }
        );

        if (response.data.responseCode === "0000") {
          setPackages(response.data.packages);
        } else {
          Swal.fire("Error", "Failed to fetch packages", "error");
        }
      } catch (error) {
        console.error("Error fetching packages", error);
        Swal.fire(
          "Error",
          "An error occurred while fetching packages.",
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPackages();
  }, [userId]); // Depend on userId

  // DataTable columns
  const columns = [
    {
      name: "Package Name",
      selector: (row) => row.packageName,
      sortable: true,
    },
    {
      name: "Package Duration",
      selector: (row) => row.packageDuration,
      sortable: true,
    },
    {
      name: "Package Price",
      selector: (row) => `Rs. ${row.packagePrice}`,
      sortable: true,
    },
    {
      name: "Package Status",
      selector: (row) => row.packageStatus,
      sortable: true,
      cell: (row) => (
        <span
          className={`badge ${
            row.packageStatus === "Active" ? "bg-success" : "bg-danger"
          }`}
        >
          {row.packageStatus}
        </span>
      ),
    },
  ];

  return (
      <div className="container">
      <Header_Company />
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div className="w-100 text-center mb-2 mb-md-0">
            <h2 className="text-center ">Retail Packages</h2>
          </div>
        </div>
        <div className="card-body">
        {/* Loading Spinner */}
        {loading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status" />
            <p>Loading packages...</p>
          </div>
        ) : (
          <DataTable
            columns={columns}
            data={packages}
            pagination
            highlightOnHover
            responsive
            striped
            noDataComponent="No packages available"
          />
        )}
        </div>
      </div>
      </div>
  );
};

export default RetailPackages;
